import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { AVATAR_SIZES } from '@usepepper/ui/atoms/avatar';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

export const RestaurantInfoHeaderSkeleton = () => {
  const [styles] = useStyles();
  return (
    <View style={styles.header}>
      <AnimatedSkeletonLoader
        borderRadius={AVATAR_SIZES.large / 2}
        height={AVATAR_SIZES.large}
        width={AVATAR_SIZES.large}
      />
      <View collapsable={false}>
        <AnimatedSkeletonLoader height={16} width={80} />
        <AnimatedSkeletonLoader height={8} width={66} />
      </View>
    </View>
  );
};

const useStyles = createStyles(() => ({
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 14,
    marginBottom: 8,
    marginTop: 8,
  },
}));
